import { View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useTheme } from '@/theme';
import { Card } from '@/components/ui/Card';
import { Button } from '@/components/ui/Button';
import { ThemedText, Body, Caption } from '@/components/ui/Text';

type ErrorStateVariant = 'inline' | 'full';

type ErrorStateProps = {
  title?: string;
  message: string;
  variant?: ErrorStateVariant;
  onRetry?: () => void;
  retryLabel?: string;
  details?: string;
};

export function ErrorState({
  title = 'Unable to load',
  message,
  variant = 'inline',
  onRetry,
  retryLabel = 'Retry',
  details,
}: ErrorStateProps) {
  const theme = useTheme();

  const content = (
    <View style={{ alignItems: 'center', gap: theme.spacing(1) }}>
      <Ionicons name="alert-circle-outline" size={28} color={theme.colors.error} />
      <ThemedText variant="bodyStrong" style={{ textAlign: 'center' }}>
        {title}
      </ThemedText>
      <Body color={theme.colors.textSecondary} style={{ textAlign: 'center' }}>
        {message}
      </Body>
      {details ? (
        <Caption color={theme.colors.textSecondary} style={{ textAlign: 'center' }}>
          {details}
        </Caption>
      ) : null}
      {onRetry ? (
        <Button label={retryLabel} onPress={onRetry} size="small" />
      ) : null}
    </View>
  );

  if (variant === 'full') {
    return (
      <View style={{ flex: 1, justifyContent: 'center', padding: theme.spacing(2) }}>
        {content}
      </View>
    );
  }

  return (
    <Card variant="outlined" style={{ padding: theme.spacing(2) }}>
      {content}
    </Card>
  );
}

